import React from 'react'

const CaretDown = () => {
  return (
    <div className='text-center text-3xl text-gray-500/50 my-4'>
        <i className="bi bi-caret-down-fill"></i>
    </div>
  )
}

export default CaretDown